import { createAction } from "@reduxjs/toolkit";
import { DashboardFilter } from "@store/reducers/adminDashboardReducer";

type dashboardDataFilterParams = {
  province?: string,
  district?: string,
  ward?: string,
  school_ids?: string,
  class_ids?: string,
  module_ids?: string,
  user_ids?: string,
  date_from?: string,
  date_to?: string,
  start_date?: string,
  end_date?: string
}

const FETCH_DASHBOARD_FILTERS = 'FETCH_DASHBOARD_FILTERS';
const FETCH_DASHBOARD_FILTER_DATA = 'FETCH_DASHBOARD_FILTER_DATA';
const FETCH_DASHBOARD_OVERVIEW = 'FETCH_DASHBOARD_OVERVIEW';
const FETCH_STUDENT_COUNT_BY_SCHOOLS = 'FETCH_STUDENT_COUNT_BY_SCHOOLS';
const FETCH_SUBMODULE_STATS = 'FETCH_SUBMODULE_STATS';
const FETCH_SUBMODULE_DETAILS = 'FETCH_SUBMODULE_DETAILS';
const FETCH_MODULE_STATS = 'FETCH_MODULE_STATS';
const CHANGE_DASHBOARD_FILTER = 'CHANGE_DASHBOARD_FILTER';

export const fetchDashboardFilters = createAction(FETCH_DASHBOARD_FILTERS, (dashboardDataFilter: dashboardDataFilterParams) => ({
  payload: dashboardDataFilter
}))

export const fetchDashboardFilterData = createAction(FETCH_DASHBOARD_FILTER_DATA, (dashboardDataFilter: dashboardDataFilterParams) => ({
  payload: dashboardDataFilter
}))

export const fetchDashboardOverview = createAction(FETCH_DASHBOARD_OVERVIEW);

export const fetchStudentCountBySchools = createAction(
  FETCH_STUDENT_COUNT_BY_SCHOOLS,
  (params: dashboardDataFilterParams) => {
    return {
      payload: params
    };
  }
);

export const fetchSubmoduleStats = createAction(FETCH_SUBMODULE_STATS, (params: dashboardDataFilterParams) => ({
  payload: params
}));

export const fetchSubmoduleDetails = createAction(FETCH_SUBMODULE_DETAILS, (params: dashboardDataFilterParams) => ({
  payload: params
}));

export const fetchModuleStats = createAction(FETCH_MODULE_STATS, (params: dashboardDataFilterParams) => ({
  payload: params
}));

export const changeFilterDashboard = createAction(CHANGE_DASHBOARD_FILTER, (dashboardDataFilter: DashboardFilter) => ({
  payload: dashboardDataFilter
}))
